/**
 * Custom error for authentication session expiration
 *
 * Thrown when:
 * - Silent token refresh fails (refresh token expired)
 * - User needs to re-authenticate
 *
 * Caught by:
 * - AuthProvider: Clears auth state and redirects to landing with returnUrl
 * - Axios interceptor: Triggers re-authentication flow
 */
export class AuthSessionExpiredError extends Error {
  constructor(message = 'Authentication session expired - please login again') {
    super(message);
    this.name = 'AuthSessionExpiredError';

    // Maintains proper stack trace in V8 engines
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthSessionExpiredError);
    }
  }
}

/**
 * Type guard to check if error is AuthSessionExpiredError
 */
export function isAuthSessionExpiredError(
  error: unknown
): error is AuthSessionExpiredError {
  return error instanceof AuthSessionExpiredError;
}
